export default Object.freeze({
    //   API_HOST: 'http://192.168.7.146:9097/api',
    //API_HOST: 'http://192.168.9.16:9097/api',
    // API_HOST: 'http://localhost:9097/api',
    // API_HOST: 'http://api.ecto-test.cf/api',
	API_HOST: 'https://api.aquazor.ru/api',
	UPDATE_PERIOD: 5000
})



// WEBPACK FOOTER //
// ./src/config.js